var map = {
	"./Polygon-01.svg": 9826,
	"./Polygon-02.svg": 6929,
	"./Polygon-03.svg": 2544,
	"./Polygon-04.svg": 15,
	"./Polygon-05.svg": 5374,
	"./Polygon-06.svg": 8349,
	"./Polygon-07.svg": 988,
	"./Polygon-08.svg": 7867
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 637;